const SOURCES = {
    "ACS": {
      "sourceName": "US Census Bureau",
      "datasetName": "American Community Survey (ACS) 5-Year Estimates",
      "datasetLink": "https://www.census.gov/data/developers/data-sets/acs-5year.html",
     
    }, 
    "BPS": {
      "sourceName": "US Census Bureau",
      "datasetName": "Building Permits Survey",
      "datasetLink": "https://www.census.gov/construction/bps/index.html",
    }
  }

const populationGrowthData = {
  aboutDescription: "This metric tracks the annual percentage change in the total population.",
  sources: [
    {
      sourceName: SOURCES["ACS"].sourceName,
      datasetName: SOURCES["ACS"].datasetName,
      datasetLink: SOURCES["ACS"].datasetLink,
      retrievedOn: "June 2, 2025",
      variables: [
        {
          name: "B01003_001E",
          commonName: "Total Population",
          url: "https://data.census.gov/table/ACSDT5Y2023.B01003?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
      ],
    },
  ],
  metricDefinition: "The annual increase in residents. Higher growth increases housing demand and can put pressure on avaialability and affordability if housing supply doesn't keep pace.",
  calculationFormula:
    "(Population in Current Year¹ - Population in Previous Year¹) / Population in Previous Year¹ * 100",
};


const newlyPermittedUnitsData = {
  aboutDescription: "This metric tracks the annual percentage change in the total population.",
  sources: [
    {
      sourceName: SOURCES["ACS"].sourceName,
      datasetName: SOURCES["ACS"].datasetName,
      datasetLink: SOURCES["ACS"].datasetLink,
      retrievedOn: "June 2, 2025",
      variables: [
        {
          name: "B01003_001E",
          commonName: "Total Population",
          url: "https://data.census.gov/table/ACSDT5Y2023.B01003?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
      ],
    },
    {
      sourceName: SOURCES["BPS"].sourceName,
      datasetName: SOURCES["BPS"].datasetName,
      datasetLink: SOURCES["BPS"].datasetLink,
      retrievedOn: "June 2, 2025",
      variables: [
        {
          name: "Newly Permitted Housing Units",
          commonName: "Newly Permitted Housing Units",
          url: "https://www.census.gov/construction/bps/visualizations/datatool/index.html",
        },
      ],
    },
  ],
  metricDefinition: "The number of housing units approved for construction per 1,000 people. Indicates how actively a city is adding supply in response to population or market demand.",
  calculationFormula:
    "(Newly Permitted Housing Units²) / (Total Population¹ / 1000)"
};

const housingStockGrowthData = {
  aboutDescription: "This",
  sources: [
    {
      sourceName: SOURCES["ACS"].sourceName,
      datasetName: SOURCES["ACS"].datasetName,
      datasetLink: SOURCES["ACS"].datasetLink,
      retrievedOn: "June 2, 2025",
      variables: [
        {
          name: "B25001_001E",
          commonName: "Total Existing Housing Units",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25001?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
      ],
    },
    {
      sourceName: SOURCES["BPS"].sourceName,
      datasetName: SOURCES["BPS"].datasetName,
      datasetLink: SOURCES["BPS"].datasetLink,
      retrievedOn: "June 2, 2025",
      variables: [
        {
          name: "Newly Permitted Housing Units",
          commonName: "Newly Permitted Housing Units",
          url: "https://www.census.gov/construction/bps/visualizations/datatool/index.html",
        },
      ],
    },
  ],
  metricDefinition: "The annual percentage increase in total housing units. Measures how quickly a city is expanding its housing supply to meet current or future demand.",
  calculationFormula:
    "(((Total Existing Housing Units¹ +  Newly Permited Housing Units²) / (Total Existing Housing Units¹) - 1) * 100)",
};

const housingUnitsPer1kData = {
  aboutDescription: "This metric tracks the annual percentage change in the total population.",
  sources: [
    {
      sourceName: SOURCES["ACS"].sourceName,
      datasetName: SOURCES["ACS"].datasetName,
      datasetLink: SOURCES["ACS"].datasetLink,
      retrievedOn: "June 2, 2025",
      variables: [
        {
          name: "B25001_001E",
          commonName: "Total Existing Housing Units",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25001?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B01003_001E",
          commonName: "Total Population",
          url: "https://data.census.gov/table/ACSDT5Y2023.B01003?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
      ],
    },
  ],
  metricDefinition: "The total number of housing units relative to the population size. A higher ratio suggests better availability and less pressure on housing demand.",
  calculationFormula:
    "(Total Existing Housing Units¹) / (Total Population² / 1000)",
};

const medianHousingAgeData = {
  aboutDescription: "This metric tracks the median housing age in years.",
  sources: [
    {
      sourceName: SOURCES["ACS"].sourceName,
      datasetName: SOURCES["ACS"].datasetName,
      datasetLink: SOURCES["ACS"].datasetLink,
      retrievedOn: "June 2, 2025",
      variables: [
        {
          name: "B25034_001E",
          commonName: "Total Units Built All Time",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25034?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B25034_002E",
          commonName: "Total Units Built 2014 or Later",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25034?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B25034_003E",
          commonName: "Total Units Built Between 2010 and 2013",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25034?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B25034_004E",
          commonName: "Total Units Built Between 2000 and 2009",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25034?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B25034_005E",
          commonName: "Total Units Built Between 1990 and 1999",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25034?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B25034_006E",
          commonName: "Total Units Built Between 1980 and 1989",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25034?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B25034_007E",
          commonName: "Total Units Built Between 1970 and 1979",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25034?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B25034_008E",
          commonName: "Total Units Built Between 1960 and 1969",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25034?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B25034_009E",
          commonName: "Total Units Built Between 1950 and 1959",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25034?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B25034_010E",
          commonName: "Total Units Built Between 1940 and 1949",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25034?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B25034_011E",
          commonName: "Total Units Built 1939 or Earlier",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25034?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
      ],
    },
  ],
  metricDefinition: "The midpoint age of all housing units. Older housing stock may indicate limited new development and potential issues with housing quality or suitability.",
  calculationFormula:
    "We have housing data by decade it was built, not individual years. To find median housing age, we found which band indicated half of the units built before that band and half after, and then interpolated the year based on the distribution of units before and after it.",
};

const multiFamilyShareData = {
  aboutDescription: "The percentage of homes in multifamily buildings (e.g. apartments, condos). Higher values suggest more rental availability and density, often associated with affordability and urban living.",
  sources: [
    {
      sourceName: SOURCES["ACS"].sourceName,
      datasetName: SOURCES["ACS"].datasetName,
      datasetLink: SOURCES["ACS"].datasetLink,
      retrievedOn: "June 2, 2025",
      variables: [
        {
          name: "B25034_001E",
          commonName: "Total Units Built All Time",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25034?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B25024_004E",
          commonName: "Existing Units in 2-Unit Structures",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25024?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B25024_005E",
          commonName: "Existing Units in 3-to-4-Unit Structures",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25024?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B25024_006E",
          commonName: "Existing Units in 5-to-9-Unit Structures",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25024?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B25024_007E",
          commonName: "Existing Units in 10-to-19-Unit Structures",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25024?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B25024_008E",
          commonName: "Existing Units in 20-to-49-Unit Structures",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25024?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B25024_009E",
          commonName: "Existing Units in 50-Plus-Unit Structures",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25024?d=ACS+5-Year+Estimates+Detailed+Tables",
        }
      ],
    },
  ],
  metricDefinition: "Multi-family share is an indicator to how well a given jursidiction is meeting high-density housing needs.",
  calculationFormula:
  "((Existing Units in 2-Unit Structures¹ + Existing Units in 3-to-4-Unit Structures² + Existing Units in 5-to-9-Unit Structures³ + Existing Units in 10-to-19-Unit Structures⁴ + Existing Units in 20-to-49-Unit Structures⁵ + Existing Units in 50-Plus-Unit Structures⁶) / (Total Existing Housing Units¹)) * 100",
};

const priceToIncomeRatioData = {
  aboutDescription: "This metric tracks the percentage of existing housing units that are multi-family (2+ Units in Structure).",
  sources: [
    {
      sourceName: SOURCES["ACS"].sourceName,
      datasetName: SOURCES["ACS"].datasetName,
      datasetLink: SOURCES["ACS"].datasetLink,
      retrievedOn: "June 2, 2025",
      variables: [
        {
          name: "B25077_001E",
          commonName: "Median Home Value",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25077?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B19013_001E",
          commonName: "Median Household Income",
          url: "https://data.census.gov/table/ACSDT5Y2023.B19013?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
      ],
    },
  ],
  metricDefinition: "The ratio of median home value to median household income. A higher ratio signals reduced homeownership affordability and potential housing cost burden.",
  calculationFormula:
  "( Median Home Value¹ / Median Household Income² )",
};

const rentalBurdenShareData = {
  aboutDescription: "This metric tracks the median housing age in years.",
  sources: [
    {
      sourceName: SOURCES["ACS"].sourceName,
      datasetName: SOURCES["ACS"].datasetName,
      datasetLink: SOURCES["ACS"].datasetLink,
      retrievedOn: "June 2, 2025",
      variables: [
        {
          name: "B25070_007E",
          commonName: "Renters Paying 30 to 34.9 Pct of Income as Rent",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25070?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B25070_008E",
          commonName: "Renters Paying 35 to 39.9 Pct of Income as Rent",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25070?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B25070_009E",
          commonName: "Renters Paying 40 to 49.9 Pct of Income as Rent",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25070?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B25070_010E",
          commonName: "Renters Paying 50+ Pct of Income as Rent",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25070?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B25003_003E",
          commonName: "Renter Occupied Housing Units",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25003?d=ACS+5-Year+Estimates+Detailed+Tables",
        }
      ],
    },
  ],
  metricDefinition: "The share of renters spending more than 30% of income on rent. Indicates rental affordability pressure; higher values mean more households are financially strained.",
  calculationFormula:
  "((Renters Paying 30 to 34.9 Pct of Income as Rent¹ + Renters Paying 35 to 39.9 Pct of Income as Rent² + Renters Paying 40 to 49.9 Pct of Income as Rent³ + Renters Paying 50+ Pct of Income as Rent⁴) / (Renter Occupied Housing Units¹)) * 100",
}

const rentalVacancyRateData = {
  aboutDescription: "This metric tracks the median housing age in years.",
  sources: [
    {
      sourceName: SOURCES["ACS"].sourceName,
      datasetName: SOURCES["ACS"].datasetName,
      datasetLink: SOURCES["ACS"].datasetLink,
      retrievedOn: "June 2, 2025",
      variables: [
        {
          name: "B25004_003E",
          commonName: "Vacant Units for Rent",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25004?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B25003_003E",
          commonName: "Renter Occupied Housing Units",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25003?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
        {
          name: "B25004_006E",
          commonName: "Unoccupied Units with a Signed Lease",
          url: "https://data.census.gov/table/ACSDT5Y2023.B25004?d=ACS+5-Year+Estimates+Detailed+Tables",
        },
      ],
    },
  ],
  metricDefinition: "The percentage of rental units that are unoccupied and available. Lower rates suggest tight rental markets and reduced availability, potentially driving up rents.",
  calculationFormula:
  "((Vacant Units for Rent¹ + Unoccupied Units with a Signed Lease²) / (Renter Occupied Housing Units³ + Vacant Units for Rent¹ + Unoccupied Units with a Signed Lease²)) * 100",
}


export const chartsDataDefinitions: { [key: string]: typeof populationGrowthData } = {
  "Population Growth": populationGrowthData,
  "Newly Permitted Units": newlyPermittedUnitsData,
  "Housing Stock Growth": housingStockGrowthData,
  "Housing Per Capita": housingUnitsPer1kData,
  "Median Housing Age": medianHousingAgeData,
  "Multi-Family Share": multiFamilyShareData,
  "Price to Income Ratio": priceToIncomeRatioData,
  "Rental Burden Share": rentalBurdenShareData,
  "Rental Vacancy Rate": rentalVacancyRateData,
}; 